import React from "react";
import Button from "../../../components/Habitacional/core/Button/Button";

import { ReactComponent as Illustration } from "../../../assets/images/home/business.svg";

import ContentSection from "../../../components/Habitacional/ContentSection";
import { links } from "../../../config";

const BusinessSection = () => {
  return (
    <ContentSection
      title="Seguro Empresarial"
      description="Conheça as vantagens, onde comprar, as coberturas, os serviços de assistência, como acionar o seguro e as condições gerais."
      illustration={<Illustration />}
    >
      <Button
        variant="primary"
        style={{ marginTop: "32px" }}
        onClick={() => {
          window.location.href = links.empresarial.seguroEmpresarial;
        }}
      >
        MEI e pequenas empresas
      </Button>
      <Button
        variant="primary"
        style={{ marginTop: "10px" }}
        onClick={() => {
          window.location.href = links.empresarial.seguroMultirrisco;
        }}
      >
        Médias e grandes empresas
      </Button>
      <Button
        variant="primary"
        style={{ marginTop: "10px" }}
        onClick={() => {
          window.location.href = links.empresarial.seguroLoterico;
        }}
      >
        Lotérico e CCA
      </Button>
    </ContentSection>
  );
};

export default BusinessSection;
